import { Directive, ElementRef, HostListener, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

/**
 * Prod builds serve scripts from /static/kedroapp/ (deploy-url) and assets
 * live there too; the ng-serve dev server serves assets from the root
 * (/assets/...). Detect which context we're in so static assets resolve in
 * both, without depending on a /static proxy in dev.
 *
 * Returns '' in dev (relative 'assets/...' paths work as-is) and the deploy
 * prefix (e.g. '/static/kedroapp/') in prod builds.
 */
export function staticAssetPrefix(): string {
  if (environment.staticPrefix) {
    return environment.staticPrefix;
  }
  const prodDeploy = !!document.querySelector(
    'script[src*="/static/kedroapp/"]'
  );
  return prodDeploy ? '/static/kedroapp/' : '';
}

@Directive({
  selector: '[appStaticSrc]',
  standalone: true,
})
export class StaticSourceDirective implements OnInit {
  constructor(private element: ElementRef) {}

  ngOnInit(): void {
    this.updateSrcAttribute();
  }

  private staticPrefix(): string {
    return staticAssetPrefix();
  }

  private updateSrcAttribute(): void {
    const currentSrc = this.element.nativeElement.getAttribute('src') || '';
    if (currentSrc.includes('/kedroapp/')) {
      return;
    }
    const prefix = this.staticPrefix();
    // Dev: leave the relative 'assets/...' path so ng-serve serves it directly.
    if (!prefix) {
      return;
    }
    this.element.nativeElement.setAttribute(
      'src',
      prefix + currentSrc.replace(/^\//, '')
    );
  }

  @HostListener('load', ['$event'])
  onLoad(event: Event): void {
    this.updateSrcAttribute();
  }
}
